export default {
  methods: {
    isFieldEmpty(formFields, fieldName) {
			if(formFields[fieldName] !== null && formFields[fieldName] !== "") {
				return false;
			}
			return true;
    },
    setField(event, formData, fieldName) {
			formData[fieldName] = event.target.value;
			//console.warn("form field set", formData);
			this.$emit("fieldSet", formData);
		}
  }
}